/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.5.0 (NJsonSchema v10.6.6.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const FeatureApiBaseUrl = new InjectionToken<string>('FeatureApiBaseUrl');

@Injectable({
    providedIn: 'root'
})
export class FieldGroupFeatureAssignmentsFeatureClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(FeatureApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5701";
    }

    /**
     * @param dv_tenant_id The Id representing the Tenant that the request belongs to
     */
    assignFeatureToFieldGroup(dv_tenant_id: any, command: AssignFieldGroupFeatureCommand): Observable<FieldGroupFeatureAssignment> {
        let url_ = this.baseUrl + "/field-group-feature-assignments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "dv-tenant-id": dv_tenant_id !== undefined && dv_tenant_id !== null ? "" + dv_tenant_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignFeatureToFieldGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignFeatureToFieldGroup(<any>response_);
                } catch (e) {
                    return <Observable<FieldGroupFeatureAssignment>><any>_observableThrow(e);
                }
            } else
                return <Observable<FieldGroupFeatureAssignment>><any>_observableThrow(response_);
        }));
    }

    protected processAssignFeatureToFieldGroup(response: HttpResponseBase): Observable<FieldGroupFeatureAssignment> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = FieldGroupFeatureAssignment.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FieldGroupFeatureAssignment>(<any>null);
    }

    /**
     * @param dv_tenant_id The Id representing the Tenant that the request belongs to
     * @param field_group_id (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @param sort (optional) 
     */
    getFieldGroupFeatureAssignmentsPage(dv_tenant_id: any, field_group_id?: string | null | undefined, offset?: number | undefined, limit?: number | undefined, sort?: string | null | undefined): Observable<IPaginationResponseOfFieldGroupFeatureAssignment> {
        let url_ = this.baseUrl + "/field-group-feature-assignments?";
        if (field_group_id !== undefined && field_group_id !== null)
            url_ += "field_group_id=" + encodeURIComponent("" + field_group_id) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "dv-tenant-id": dv_tenant_id !== undefined && dv_tenant_id !== null ? "" + dv_tenant_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFieldGroupFeatureAssignmentsPage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFieldGroupFeatureAssignmentsPage(<any>response_);
                } catch (e) {
                    return <Observable<IPaginationResponseOfFieldGroupFeatureAssignment>><any>_observableThrow(e);
                }
            } else
                return <Observable<IPaginationResponseOfFieldGroupFeatureAssignment>><any>_observableThrow(response_);
        }));
    }

    protected processGetFieldGroupFeatureAssignmentsPage(response: HttpResponseBase): Observable<IPaginationResponseOfFieldGroupFeatureAssignment> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IPaginationResponseOfFieldGroupFeatureAssignment.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IPaginationResponseOfFieldGroupFeatureAssignment>(<any>null);
    }

    /**
     * @param dv_tenant_id The Id representing the Tenant that the request belongs to
     */
    unassignFeatureToFieldGroup(dv_tenant_id: any, fieldGroupFeatureAssignmentId: string): Observable<void> {
        let url_ = this.baseUrl + "/field-group-feature-assignments/{field-group-feature-assignment-id}";
        if (fieldGroupFeatureAssignmentId === undefined || fieldGroupFeatureAssignmentId === null)
            throw new Error("The parameter 'fieldGroupFeatureAssignmentId' must be defined.");
        url_ = url_.replace("{field-group-feature-assignment-id}", encodeURIComponent("" + fieldGroupFeatureAssignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "dv-tenant-id": dv_tenant_id !== undefined && dv_tenant_id !== null ? "" + dv_tenant_id : "",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnassignFeatureToFieldGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnassignFeatureToFieldGroup(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUnassignFeatureToFieldGroup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FieldGroupFeaturesFeatureClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(FeatureApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5701";
    }

    /**
     * @param dv_tenant_id The Id representing the Tenant that the request belongs to
     */
    get(dv_tenant_id: any): Observable<FieldGroupFeature[]> {
        let url_ = this.baseUrl + "/field-group-features";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "dv-tenant-id": dv_tenant_id !== undefined && dv_tenant_id !== null ? "" + dv_tenant_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<FieldGroupFeature[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FieldGroupFeature[]>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FieldGroupFeature[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FieldGroupFeature.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FieldGroupFeature[]>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LocationFeatureAssignmentsFeatureClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(FeatureApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5701";
    }

    /**
     * @param dv_tenant_id The Id representing the Tenant that the request belongs to
     * @return Assignment created successfully
     */
    assignFeatureToLocation(dv_tenant_id: any, assign_feature_command: AssignFeatureToLocationCommand): Observable<LocationFeatureAssignment> {
        let url_ = this.baseUrl + "/v1/field-representatives/location-feature-assignments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assign_feature_command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "dv-tenant-id": dv_tenant_id !== undefined && dv_tenant_id !== null ? "" + dv_tenant_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignFeatureToLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignFeatureToLocation(<any>response_);
                } catch (e) {
                    return <Observable<LocationFeatureAssignment>><any>_observableThrow(e);
                }
            } else
                return <Observable<LocationFeatureAssignment>><any>_observableThrow(response_);
        }));
    }

    protected processAssignFeatureToLocation(response: HttpResponseBase): Observable<LocationFeatureAssignment> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = LocationFeatureAssignment.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocationFeatureAssignment>(<any>null);
    }

    /**
     * @param dv_tenant_id The Id representing the Tenant that the request belongs to
     * @param location_id (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @param sort (optional) 
     * @return Get all assignments assigned to a location by location Id
     */
    getLocationFeatureAssignmentsPage(dv_tenant_id: any, location_id?: string | null | undefined, offset?: number | undefined, limit?: number | undefined, sort?: string | null | undefined): Observable<PaginationResponseOfLocationFeatureAssignment> {
        let url_ = this.baseUrl + "/v1/field-representatives/location-feature-assignments?";
        if (location_id !== undefined && location_id !== null)
            url_ += "location_id=" + encodeURIComponent("" + location_id) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "dv-tenant-id": dv_tenant_id !== undefined && dv_tenant_id !== null ? "" + dv_tenant_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationFeatureAssignmentsPage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationFeatureAssignmentsPage(<any>response_);
                } catch (e) {
                    return <Observable<PaginationResponseOfLocationFeatureAssignment>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaginationResponseOfLocationFeatureAssignment>><any>_observableThrow(response_);
        }));
    }

    protected processGetLocationFeatureAssignmentsPage(response: HttpResponseBase): Observable<PaginationResponseOfLocationFeatureAssignment> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginationResponseOfLocationFeatureAssignment.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginationResponseOfLocationFeatureAssignment>(<any>null);
    }

    /**
     * @param dv_tenant_id The Id representing the Tenant that the request belongs to
     * @return Assignment deleted successfully
     */
    unAssignFeatureToLocation(dv_tenant_id: any, locationFeatureAssignmentId: string): Observable<void> {
        let url_ = this.baseUrl + "/v1/field-representatives/location-feature-assignments/{location-feature-assignment-id}";
        if (locationFeatureAssignmentId === undefined || locationFeatureAssignmentId === null)
            throw new Error("The parameter 'locationFeatureAssignmentId' must be defined.");
        url_ = url_.replace("{location-feature-assignment-id}", encodeURIComponent("" + locationFeatureAssignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "dv-tenant-id": dv_tenant_id !== undefined && dv_tenant_id !== null ? "" + dv_tenant_id : "",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnAssignFeatureToLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnAssignFeatureToLocation(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUnAssignFeatureToLocation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LocationFeaturesFeatureClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(FeatureApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5701";
    }

    /**
     * @param dv_tenant_id The Id representing the Tenant that the request belongs to
     */
    getFeatures(dv_tenant_id: any): Observable<LocationFeature[]> {
        let url_ = this.baseUrl + "/v1/field-representatives/location-features";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "dv-tenant-id": dv_tenant_id !== undefined && dv_tenant_id !== null ? "" + dv_tenant_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFeatures(<any>response_);
                } catch (e) {
                    return <Observable<LocationFeature[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LocationFeature[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetFeatures(response: HttpResponseBase): Observable<LocationFeature[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationFeature.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocationFeature[]>(<any>null);
    }

    /**
     * @param dv_tenant_id The Id representing the Tenant that the request belongs to
     */
    assignLocations(dv_tenant_id: any, locationFeatureId: string, request: AssignFeatureToLocationsRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/v1/field-representatives/location-features/{location-feature-id}/assign-locations";
        if (locationFeatureId === undefined || locationFeatureId === null)
            throw new Error("The parameter 'locationFeatureId' must be defined.");
        url_ = url_.replace("{location-feature-id}", encodeURIComponent("" + locationFeatureId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "dv-tenant-id": dv_tenant_id !== undefined && dv_tenant_id !== null ? "" + dv_tenant_id : "",
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignLocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignLocations(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processAssignLocations(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }

    /**
     * @param dv_tenant_id The Id representing the Tenant that the request belongs to
     */
    unassignLocations(dv_tenant_id: any, locationFeatureId: string, request: UnssignFeatureToLocationsRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/v1/field-representatives/location-features/{location-feature-id}/unassign-locations";
        if (locationFeatureId === undefined || locationFeatureId === null)
            throw new Error("The parameter 'locationFeatureId' must be defined.");
        url_ = url_.replace("{location-feature-id}", encodeURIComponent("" + locationFeatureId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "dv-tenant-id": dv_tenant_id !== undefined && dv_tenant_id !== null ? "" + dv_tenant_id : "",
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnassignLocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnassignLocations(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUnassignLocations(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }
}

export class FieldGroupFeatureAssignment implements IFieldGroupFeatureAssignment {
    field_group_feature_assignment_id?: string;
    field_group_id?: string;
    field_group_feature_id?: string;
    id?: string;
    partition_key?: string;

    constructor(data?: IFieldGroupFeatureAssignment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field_group_feature_assignment_id = _data["field_group_feature_assignment_id"] !== undefined ? _data["field_group_feature_assignment_id"] : <any>null;
            this.field_group_id = _data["field_group_id"] !== undefined ? _data["field_group_id"] : <any>null;
            this.field_group_feature_id = _data["field_group_feature_id"] !== undefined ? _data["field_group_feature_id"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.partition_key = _data["partition_key"] !== undefined ? _data["partition_key"] : <any>null;
        }
    }

    static fromJS(data: any): FieldGroupFeatureAssignment {
        data = typeof data === 'object' ? data : {};
        let result = new FieldGroupFeatureAssignment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field_group_feature_assignment_id"] = this.field_group_feature_assignment_id !== undefined ? this.field_group_feature_assignment_id : <any>null;
        data["field_group_id"] = this.field_group_id !== undefined ? this.field_group_id : <any>null;
        data["field_group_feature_id"] = this.field_group_feature_id !== undefined ? this.field_group_feature_id : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["partition_key"] = this.partition_key !== undefined ? this.partition_key : <any>null;
        return data;
    }

    clone(): FieldGroupFeatureAssignment {
        const json = this.toJSON();
        let result = new FieldGroupFeatureAssignment();
        result.init(json);
        return result;
    }
}

export interface IFieldGroupFeatureAssignment {
    field_group_feature_assignment_id?: string;
    field_group_id?: string;
    field_group_feature_id?: string;
    id?: string;
    partition_key?: string;
}

export class AssignFieldGroupFeatureCommand implements IAssignFieldGroupFeatureCommand {
    field_group_id?: string;
    field_group_feature_id?: string;

    constructor(data?: IAssignFieldGroupFeatureCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field_group_id = _data["field_group_id"] !== undefined ? _data["field_group_id"] : <any>null;
            this.field_group_feature_id = _data["field_group_feature_id"] !== undefined ? _data["field_group_feature_id"] : <any>null;
        }
    }

    static fromJS(data: any): AssignFieldGroupFeatureCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AssignFieldGroupFeatureCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field_group_id"] = this.field_group_id !== undefined ? this.field_group_id : <any>null;
        data["field_group_feature_id"] = this.field_group_feature_id !== undefined ? this.field_group_feature_id : <any>null;
        return data;
    }

    clone(): AssignFieldGroupFeatureCommand {
        const json = this.toJSON();
        let result = new AssignFieldGroupFeatureCommand();
        result.init(json);
        return result;
    }
}

export interface IAssignFieldGroupFeatureCommand {
    field_group_id?: string;
    field_group_feature_id?: string;
}

export abstract class IPaginationResponseOfFieldGroupFeatureAssignment implements IIPaginationResponseOfFieldGroupFeatureAssignment {
    offset?: number;
    limit?: number;
    total_count?: number | null;
    sort?: string | null;
    items?: FieldGroupFeatureAssignment[];

    constructor(data?: IIPaginationResponseOfFieldGroupFeatureAssignment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offset = _data["offset"] !== undefined ? _data["offset"] : <any>null;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : <any>null;
            this.total_count = _data["total_count"] !== undefined ? _data["total_count"] : <any>null;
            this.sort = _data["sort"] !== undefined ? _data["sort"] : <any>null;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FieldGroupFeatureAssignment.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
        }
    }

    static fromJS(data: any): IPaginationResponseOfFieldGroupFeatureAssignment {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IPaginationResponseOfFieldGroupFeatureAssignment' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offset"] = this.offset !== undefined ? this.offset : <any>null;
        data["limit"] = this.limit !== undefined ? this.limit : <any>null;
        data["total_count"] = this.total_count !== undefined ? this.total_count : <any>null;
        data["sort"] = this.sort !== undefined ? this.sort : <any>null;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): IPaginationResponseOfFieldGroupFeatureAssignment {
        throw new Error("The abstract class 'IPaginationResponseOfFieldGroupFeatureAssignment' cannot be instantiated.");
    }
}

export interface IIPaginationResponseOfFieldGroupFeatureAssignment {
    offset?: number;
    limit?: number;
    total_count?: number | null;
    sort?: string | null;
    items?: FieldGroupFeatureAssignment[];
}

export class FieldGroupFeature implements IFieldGroupFeature {
    /** Id of the field group feature - a developer-friendly string, but not a user-friendly display name */
    field_group_feature_id?: string;
    /** User-friendly display name for the field group feature */
    name?: string;
    /** Detailed description for the field group feature */
    description?: string | null;
    id?: string;
    partition_key?: string;

    constructor(data?: IFieldGroupFeature) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field_group_feature_id = _data["field_group_feature_id"] !== undefined ? _data["field_group_feature_id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.partition_key = _data["partition_key"] !== undefined ? _data["partition_key"] : <any>null;
        }
    }

    static fromJS(data: any): FieldGroupFeature {
        data = typeof data === 'object' ? data : {};
        let result = new FieldGroupFeature();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field_group_feature_id"] = this.field_group_feature_id !== undefined ? this.field_group_feature_id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["partition_key"] = this.partition_key !== undefined ? this.partition_key : <any>null;
        return data;
    }

    clone(): FieldGroupFeature {
        const json = this.toJSON();
        let result = new FieldGroupFeature();
        result.init(json);
        return result;
    }
}

export interface IFieldGroupFeature {
    /** Id of the field group feature - a developer-friendly string, but not a user-friendly display name */
    field_group_feature_id?: string;
    /** User-friendly display name for the field group feature */
    name?: string;
    /** Detailed description for the field group feature */
    description?: string | null;
    id?: string;
    partition_key?: string;
}

export class LocationFeatureAssignment implements ILocationFeatureAssignment {
    location_feature_assignment_id?: string;
    location_id?: string;
    location_feature_id?: string;
    id?: string;
    partition_key?: string;

    constructor(data?: ILocationFeatureAssignment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location_feature_assignment_id = _data["location_feature_assignment_id"] !== undefined ? _data["location_feature_assignment_id"] : <any>null;
            this.location_id = _data["location_id"] !== undefined ? _data["location_id"] : <any>null;
            this.location_feature_id = _data["location_feature_id"] !== undefined ? _data["location_feature_id"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.partition_key = _data["partition_key"] !== undefined ? _data["partition_key"] : <any>null;
        }
    }

    static fromJS(data: any): LocationFeatureAssignment {
        data = typeof data === 'object' ? data : {};
        let result = new LocationFeatureAssignment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location_feature_assignment_id"] = this.location_feature_assignment_id !== undefined ? this.location_feature_assignment_id : <any>null;
        data["location_id"] = this.location_id !== undefined ? this.location_id : <any>null;
        data["location_feature_id"] = this.location_feature_id !== undefined ? this.location_feature_id : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["partition_key"] = this.partition_key !== undefined ? this.partition_key : <any>null;
        return data;
    }

    clone(): LocationFeatureAssignment {
        const json = this.toJSON();
        let result = new LocationFeatureAssignment();
        result.init(json);
        return result;
    }
}

export interface ILocationFeatureAssignment {
    location_feature_assignment_id?: string;
    location_id?: string;
    location_feature_id?: string;
    id?: string;
    partition_key?: string;
}

export class AssignFeatureToLocationCommand implements IAssignFeatureToLocationCommand {
    location_id?: string;
    location_feature_id?: string;

    constructor(data?: IAssignFeatureToLocationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location_id = _data["location_id"] !== undefined ? _data["location_id"] : <any>null;
            this.location_feature_id = _data["location_feature_id"] !== undefined ? _data["location_feature_id"] : <any>null;
        }
    }

    static fromJS(data: any): AssignFeatureToLocationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AssignFeatureToLocationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location_id"] = this.location_id !== undefined ? this.location_id : <any>null;
        data["location_feature_id"] = this.location_feature_id !== undefined ? this.location_feature_id : <any>null;
        return data;
    }

    clone(): AssignFeatureToLocationCommand {
        const json = this.toJSON();
        let result = new AssignFeatureToLocationCommand();
        result.init(json);
        return result;
    }
}

export interface IAssignFeatureToLocationCommand {
    location_id?: string;
    location_feature_id?: string;
}

export class PaginationResponseOfLocationFeatureAssignment implements IPaginationResponseOfLocationFeatureAssignment {
    offset?: number;
    limit?: number;
    total_count?: number | null;
    sort?: string | null;
    items?: LocationFeatureAssignment[];

    constructor(data?: IPaginationResponseOfLocationFeatureAssignment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offset = _data["offset"] !== undefined ? _data["offset"] : <any>null;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : <any>null;
            this.total_count = _data["total_count"] !== undefined ? _data["total_count"] : <any>null;
            this.sort = _data["sort"] !== undefined ? _data["sort"] : <any>null;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LocationFeatureAssignment.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
        }
    }

    static fromJS(data: any): PaginationResponseOfLocationFeatureAssignment {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationResponseOfLocationFeatureAssignment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offset"] = this.offset !== undefined ? this.offset : <any>null;
        data["limit"] = this.limit !== undefined ? this.limit : <any>null;
        data["total_count"] = this.total_count !== undefined ? this.total_count : <any>null;
        data["sort"] = this.sort !== undefined ? this.sort : <any>null;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginationResponseOfLocationFeatureAssignment {
        const json = this.toJSON();
        let result = new PaginationResponseOfLocationFeatureAssignment();
        result.init(json);
        return result;
    }
}

export interface IPaginationResponseOfLocationFeatureAssignment {
    offset?: number;
    limit?: number;
    total_count?: number | null;
    sort?: string | null;
    items?: LocationFeatureAssignment[];
}

export class LocationFeature implements ILocationFeature {
    /** Id of the location feature - a developer-friendly string, but not a user-friendly display name */
    location_feature_id?: string;
    /** User-friendly display name for the location feature */
    name?: string;
    /** Detailed description for the location feature */
    description?: string;
    id?: string;
    partition_key?: string;

    constructor(data?: ILocationFeature) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location_feature_id = _data["location_feature_id"] !== undefined ? _data["location_feature_id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.partition_key = _data["partition_key"] !== undefined ? _data["partition_key"] : <any>null;
        }
    }

    static fromJS(data: any): LocationFeature {
        data = typeof data === 'object' ? data : {};
        let result = new LocationFeature();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location_feature_id"] = this.location_feature_id !== undefined ? this.location_feature_id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["partition_key"] = this.partition_key !== undefined ? this.partition_key : <any>null;
        return data;
    }

    clone(): LocationFeature {
        const json = this.toJSON();
        let result = new LocationFeature();
        result.init(json);
        return result;
    }
}

export interface ILocationFeature {
    /** Id of the location feature - a developer-friendly string, but not a user-friendly display name */
    location_feature_id?: string;
    /** User-friendly display name for the location feature */
    name?: string;
    /** Detailed description for the location feature */
    description?: string;
    id?: string;
    partition_key?: string;
}

export class AssignFeatureToLocationsRequest implements IAssignFeatureToLocationsRequest {
    location_ids?: string[];

    constructor(data?: IAssignFeatureToLocationsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["location_ids"])) {
                this.location_ids = [] as any;
                for (let item of _data["location_ids"])
                    this.location_ids!.push(item);
            }
            else {
                this.location_ids = <any>null;
            }
        }
    }

    static fromJS(data: any): AssignFeatureToLocationsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AssignFeatureToLocationsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.location_ids)) {
            data["location_ids"] = [];
            for (let item of this.location_ids)
                data["location_ids"].push(item);
        }
        return data;
    }

    clone(): AssignFeatureToLocationsRequest {
        const json = this.toJSON();
        let result = new AssignFeatureToLocationsRequest();
        result.init(json);
        return result;
    }
}

export interface IAssignFeatureToLocationsRequest {
    location_ids?: string[];
}

export class UnssignFeatureToLocationsRequest implements IUnssignFeatureToLocationsRequest {
    location_ids?: string[];

    constructor(data?: IUnssignFeatureToLocationsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["location_ids"])) {
                this.location_ids = [] as any;
                for (let item of _data["location_ids"])
                    this.location_ids!.push(item);
            }
            else {
                this.location_ids = <any>null;
            }
        }
    }

    static fromJS(data: any): UnssignFeatureToLocationsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UnssignFeatureToLocationsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.location_ids)) {
            data["location_ids"] = [];
            for (let item of this.location_ids)
                data["location_ids"].push(item);
        }
        return data;
    }

    clone(): UnssignFeatureToLocationsRequest {
        const json = this.toJSON();
        let result = new UnssignFeatureToLocationsRequest();
        result.init(json);
        return result;
    }
}

export interface IUnssignFeatureToLocationsRequest {
    location_ids?: string[];
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}